module.exports = __webpack_public_path__ + "assets/img/icon-z3-2.8dc81e94.png";